<template>

  <LayoutPane
    :name      = "name"
  >

    <div class="tab-bar">

      <!-- Tabs -->
      <div class="tab-row">
        <draggable
          class     = "d-flex flex-grow-1"
          v-model   = "tabs"
          group     = "tabs"
        >

          <TabButton 
            v-for     = "tab of tabs"
            class     = "tab"
            :key      = "tab"
            :label    = "tab"
            @remove   = "onRemoveTab(tab);"
          >
          </TabButton>

        </draggable>
      </div>

      <!-- Tab Picker -->
      <v-menu
        left
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-btn 
            icon
            v-on      = "on"
            :disabled = "availableTabs.length === 0"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>

        <v-list
          dense
        >
          <v-list-item
            v-for     = "tab of availableTabs"
            :key      = "tab"
            @click    = "onAddTab(tab);"
          >
            {{ tab }}
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- Lock -->
      <v-btn
        icon
        @click  = "locked = !locked"
      >
        <v-icon>{{ locked ? 'mdi-lock' : 'mdi-lock-open-variant' }}</v-icon>
      </v-btn>

    </div>
    
  </LayoutPane>

</template>

<script>

// #region Imports

/* Telestream */
import LayoutPane from './LayoutPane.vue';
import TabButton from './TabButton.vue';

// #endregion Imports

export default {

  // #region Properties

  props: {
    which:  String,
    layout: Object
  },
  computed: {
    name() {
      const which = this.which === 'top' ? 'Top' : 'Bottom';
      return `${which} Tabs`;
    },
    tabs: {
      get() {
        return this.which === 'top' ? this.layout.topTabs.tabs : this.layout.bottomTabs.tabs;
      },
      set(tabs) {
        if (this.which === 'top') {
          this.layout.topTabs.tabs = tabs;
        } else {
          this.layout.bottomTabs.tabs = tabs;
        }
      }
    },
    availableTabs() {
      const taken = this.which === 'top' ? this.layout.topTabs.tabs : this.layout.bottomTabs.tabs;
      
      const all = [
        'Annotations',
        'Audio',
        'Clips',
        'Frame',
        'Inspector',
        'Plugins',
        'Scopes'
      ];

      return all.filter(t => !taken.includes(t));
    },
    locked: {
      get() {
        return this.which === 'top' ? this.layout.topTabs.locked : this.layout.bottomTabs.locked;
      },
      set(value) {
        this.layout[`${this.which}Tabs`].locked = value;
      }
    }
  },
  components: {
    LayoutPane,
    TabButton
  },

  // #endregion Properties

  // #region Methods

  methods: {

    onRemoveTab(tab) {
      if (this.which === 'top') {
        this.layout.topTabs.tabs = this.layout.topTabs.tabs.filter(t => t !== tab);
      } else {
        this.layout.bottomTabs.tabs = this.layout.bottomTabs.tabs.filter(t => t !== tab);
      }
    },

    onAddTab(tab) {
      if (this.which === 'top') {
        this.layout.topTabs.tabs.push(tab);
        this.layout.bottomTabs.tabs = this.layout.bottomTabs.tabs.filter(t => t != tab);
      } else {
        this.layout.bottomTabs.tabs.push(tab);
        this.layout.topTabs.tabs = this.layout.topTabs.tabs.filter(t => t != tab);
      }
    }

  }

  // #endregion Methods

}

</script>

<style scoped lang="scss">

.tab-bar {
  display:        flex;
  flex-direction: row;
  margin-top:     8px;

  .tab-row {
    flex:           1;

    display:        flex;
    flex-direction: row;

    width:          0px;
    overflow:       auto;

    padding:        6px 0px;
    border:         1px solid rgba(0, 0, 0, 0.2);
    border-left:    0px;
    border-right:   0px;

    .tab {
      margin:         0px 4px;
    }

    &::-webkit-scrollbar {
      height:                 10px;
      width:                  10px;
    }

    &::-webkit-scrollbar-track {
      background-color:       rgba(0, 0, 0, 0.2);
    }

    &::-webkit-scrollbar-thumb {
      background-color:       rgba(255, 255, 255, 0.7);
    }

    &::-webkit-scrollbar-corner {
      background-color:       transparent;
    }
  }
}

</style>